import toast from "react-hot-toast";
import moment from "moment";
import "moment/locale/fr";

export const formatNumber = (num: number | any): string => {
  if (!num) return "0,00";
  return num?.toLocaleString("en-US");
};

export const dateFormat = (
  date: string | Date | undefined | any,
  locale: string = "fr"
): string => {
  moment.locale(locale);
  return moment(date).format("LL");
};
// export function formatNumber(num: number): string | any {
//   if (typeof num !== 'number' || isNaN(num)) {
//     return '0'; // Handle non-number cases
//   }

//   if (num >= 1_000_000_000) {
//     return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
//   }
//   if (num >= 1_000_000) {
//     return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
//   }
//   if (num >= 1_000) {
//     return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
//   }
//   return Math.round(num).toString();
// }

export const dateFormat_str = (date: string | Date): string => {
  moment.locale("fr");
  return moment(date).format("DD/MM/YYYY");
};

export const capitalizeWords = (str:string) : string => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const timeAgoShort = (date: string | Date | undefined): string => {
  const now = moment();
  const past = moment(date);
  const diff = moment.duration(now.diff(past));

  if (diff.asSeconds() < 60) return `${Math.floor(diff.asSeconds())}s`;
  if (diff.asMinutes() < 60) return `${Math.floor(diff.asMinutes())}m`;
  if (diff.asHours() < 24) return `${Math.floor(diff.asHours())}h`;
  if (diff.asDays() < 30) return `${Math.floor(diff.asDays())}j`; // j = jour
  if (diff.asMonths() < 12) return `${Math.floor(diff.asMonths())}mo`;
  return `${Math.floor(diff.asYears())}a`; // a = année
};

export const timeAgo = (date: string | Date | any): string => {
  moment.locale("fr");
  return moment(date).fromNow();
};

export const formatAbbreviatedMoney = (value: number): string => {
  return "$" + formatNumber(value);
};

export const formatMoney = (value: number): string => {
  if (typeof value !== "number" || isNaN(value)) {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(0);
  }

  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value); // Removed formatNumber call as it's not suitable for currency
};

export const errorNotification = (message: any) => {
  //addToast(message, { autoDismiss: true, appearance: "error" });
  toast.error(message);
};
export const successNotification = (message: any) => {
  //addToast(message, { autoDismiss: true, appearance: "success" });
  toast.success(message);
};

export const limitText = (text: string | undefined, limit: number): string => {
  return text && text.length > limit
    ? text.slice(0, limit) + "..."
    : text ?? "";
};

export function maskEmail(
  email: string,
  {
    keepLocalStart = 2, // combien de caractères garder au début (local part)
    replacement = "...", // chaîne de remplacement
  }: { keepLocalStart?: number; replacement?: string } = {}
): string {
  if (!email || typeof email !== "string") return email;
  const atIndex = email.indexOf("@");
  if (atIndex === -1) return email; // pas un email valide, retourner tel quel

  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);

  if (local.length <= keepLocalStart + 1) {
    // trop court => on garde 1 char + replacement
    return `${local.slice(0, 1)}${replacement}@${domain}`;
  }

  const start = local.slice(0, keepLocalStart);
  return `${start}${replacement}@${domain}`;
}
